import { DiscountType, PriceType } from '@app-types/product';

function getPromotionsAmount(promoList: DiscountType[]): number {
    return promoList.reduce((acc, promotion) => acc + promotion?.value, 0);
}

function applyPromos(incitativePromos: DiscountType[]): DiscountType[] {
    const appliedPromos: DiscountType[] = [];
    incitativePromos.forEach((promo) => appliedPromos.push(promo));
    return appliedPromos;
}

function updatePricesWithPromos(prices: PriceType, promoAmount: number): void {
    prices.final -= promoAmount;
    prices.initial -= promoAmount;
}

export function getPricesWithPromos(prices: PriceType, promos: DiscountType[], isConnected: boolean): PriceType {
    if (isConnected) {
        prices.duration = Math.max(...promos.map((promo) => promo.duration ?? 0));
        return prices;
    }
    const pricesUpdated: PriceType = {
        initial: prices.initial ?? 0,
        subsidized: prices.subsidized ?? 0,
        forever: prices.forever ?? 0,
        final: prices.final ?? 0,
        promoLabel: '',
    };

    const incitativePromos = promos?.filter((p) => p.isIncitation);
    const appliedPromos = applyPromos(incitativePromos);

    const promoAmount = getPromotionsAmount(appliedPromos);
    updatePricesWithPromos(pricesUpdated, promoAmount);

    const firstPromoWithLabel = appliedPromos.find((promo) => Boolean(promo?.pennant));
    pricesUpdated.promoLabel = firstPromoWithLabel?.pennant ?? '';
    pricesUpdated.duration = Math.max(...promos.map((promo) => promo.duration ?? 0));

    if (pricesUpdated.forever && pricesUpdated.final === pricesUpdated.forever) {
        pricesUpdated.duration = 0;
    }
    return pricesUpdated;
}
